<div class="customers">
    <div class="row">
        <div class="col-sm-12">
            <div class="divDimension">
                <div class="row">
                    <div class="col-sm-11">
                        <p class="dataFecha" style="margin: 20px;">ESTRATEGIA {{index + 1}}</p>
                    </div>
                    <div class="col-sm-1">
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="!isCollapsed" alt="avatar" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                        <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="index >= 3" (click)="eliminarEstrategia(index)" ><i class="fas fa-trash"></i></button>
                    </div>
                    <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">

                        <div class="row mb-3" style="padding: 0 20px; margin-left: 10px;" *ngIf="index <3" >
                            <textarea class="text-area-consulta" name="estrategia" [(ngModel)]="estrategia.estrategia" [disabled]="true"></textarea>
                        </div>
                        <div class="row mb-3" style="padding: 0 20px; margin-left: 10px;" *ngIf="index >= 3" >
                            <textarea class="text-area-consulta" name="estrategia" [(ngModel)]="estrategia.estrategia" ></textarea>
                        </div>
                        <div *ngFor="let actividad of estrategia.actividades; let indice=index">
                            <app-actividad-pgc [actividad]="actividad" [index]="indice" [readonly]="readonly"></app-actividad-pgc>
                        </div> 
                        <div class="row  justify-content-end mb-2">
                            <button type="button" (click)="agregarActividad()"  class="btn btn-light btn-send" style="width: 250px;" [disabled]="estrategia.actividades.length > 3 " *ngIf="!readonly" >AGREGAR ACTIVIDAD</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>